import React, { useState, useEffect } from 'react';
import { Form, Button } from 'react-bootstrap';

function KlinikDiyetisyenFormu({ mevcutDiyetisyen, onFormSubmit, onIptal }) {
  const [formData, setFormData] = useState({
    kullanici_adi: '',
    eposta: '',
    telefon: '',
    sifre: '',
  });

  // Eğer düzenleme modu için bir diyetisyen verisi geldiyse, formu onunla doldur
  useEffect(() => {
    if (mevcutDiyetisyen) {
      setFormData({
        kullanici_adi: mevcutDiyetisyen.kullanici_adi || '',
        eposta: mevcutDiyetisyen.eposta || '',
        telefon: mevcutDiyetisyen.telefon || '',
        sifre: '', // Düzenleme modunda şifre alanını güvenlik için boş başlat
      });
    }
  }, [mevcutDiyetisyen]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onFormSubmit(formData); // Toplanan veriyi ana bileşene gönder
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        <Form.Label>Kullanıcı Adı</Form.Label>
        <Form.Control type="text" name="kullanici_adi" value={formData.kullanici_adi} onChange={handleChange} required />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>E-posta</Form.Label>
        <Form.Control type="email" name="eposta" value={formData.eposta} onChange={handleChange} required />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Telefon (İsteğe Bağlı)</Form.Label>
        <Form.Control type="tel" name="telefon" value={formData.telefon} onChange={handleChange} />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Şifre</Form.Label>
        <Form.Control 
          type="password" 
          name="sifre" 
          value={formData.sifre} 
          onChange={handleChange} 
          placeholder={mevcutDiyetisyen ? 'Değiştirmek için doldurun' : ''} 
          required={!mevcutDiyetisyen} // Sadece yeni eklerken zorunlu
        />
      </Form.Group>

      <div className="d-flex justify-content-end">
        <Button variant="secondary" onClick={onIptal} className="me-2">
          İptal
        </Button>
        <Button variant="primary" type="submit">
          {mevcutDiyetisyen ? 'Güncelle' : 'Kaydet'}
        </Button>
      </div>
    </Form>
  );
}

export default KlinikDiyetisyenFormu;